import React from "react";
import classNames from "classnames";

interface ButtonPropsI extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    text?: string,
    variant: "primary" | "secondary" | "icon",
    iconElement?: React.ReactNode
}

const Button: React.FC<ButtonPropsI> = ({text, variant, iconElement, className, ...defaultButtonProps}) => {

    let buttonClasses = classNames({
        "blj-store-locator__button": true,
        "blj-store-locator__button_primary": variant === "primary",
        "blj-store-locator__button_secondary": variant === "secondary",
        "blj-store-locator__button_icon": variant === "icon"
    });

    // Adding custom class name if it is provided
    if (className) {
        buttonClasses += ` ${className}`;
    }

    return (
        <button
            className={buttonClasses}
            {...defaultButtonProps}
        >
            <div className="blj-store-locator__button-content">
                {iconElement && (
                    iconElement
                )}
                {text && (
                    <span className="blj-store-locator__button-text">
                        {text}
                    </span>
                )}
            </div>
        </button>
    )
}

export default Button;